"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargaDate = void 0;
var bson_1 = require("bson");
var CargaDate = /** @class */ (function () {
    function CargaDate(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.dateAndTime, dateAndTime = _c === void 0 ? '' : _c;
        this._id = _id;
        this.dateAndTime = dateAndTime;
    }
    return CargaDate;
}());
exports.CargaDate = CargaDate;
//# sourceMappingURL=CargaDate.js.map